import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'rass-summary-content',
  shadow: true,
})
export class RassSummaryContent {
  @Prop() summaryHtml: string;
  render(): void {
    return (
      <Host>
        <div
          innerHTML={this.summaryHtml}
          aria-live="polite"
          // tabindex on non-interactive element is added for legal reasons
          tabindex="0"
          id="summary-content"
        />
      </Host>
    ) as void;
  }
}
